import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
  fieldGroup: {
    paddingBottom: theme.spacing(3),
  },
}));
